<form class="auth-login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error?.title || error?.body">
    <div class="alert-body" *ngIf="error?.body">
      <div [innerHTML]="error?.body"></div>
    </div>
  </ngb-alert>

  <ngb-alert
    [type]="'info'" [dismissible]="true"
    *ngIf="f.password.errors?.invalid && (submitted || f.password.touched) && showPasswordErrorAlert"
    (closed)="showPasswordErrorAlert = false">
    <div class="alert-body p-1">
      <div class="d-flex align-items-start gap-2">
        <div class="info-icon-circle mr-2">i</div>
        <div>
          <b>Having trouble with passwords?</b><br/>
          <span class="text-black">Don't worry, click forgot password to reset it</span>
        </div>
      </div>
    </div>
  </ngb-alert>

  <div class="form-group mt-2 mb-0">
    <ngb-alert [type]="'warning'" [dismissible]="true" *ngIf="showForgotUsernameInfo">
      <div class="alert-body">
        <b>Forgotten your username?</b><br />Don't worry, click forgot username to retrieve
      </div>
    </ngb-alert>
    <div class="d-flex align-items-center justify-content-between">
      <label class="form-label text-black" [class.mobile-font]="selectedRole == 'Student'" for="login-username">
        {{ userNameText }}
      </label>
    </div>
    <input
      #username type="text" formControlName="username" class="form-control"
      [ngClass]="{'is-invalid error': f.username.errors && (submitted || usernameCheck || f.username.touched)}"
      placeholder="{{ userNamePlaceholder }}" aria-describedby="login-username" autofocus=""
      tabindex="1" id="login-username" [readonly]="userChecked" (keydown.enter)="onUsernameEnter($event)"
    />
    <small *ngIf="selectedRole == 'Student'">
      <span class="text-primary">Admnno@schoolcode</span> eg.
      <span class="text-primary">1234@stpauls</span> or <span class="text-primary">0700000000</span>
    </small>

    <div class="d-flex justify-content-between" [ngClass]="{ 'mb-md-3': !userChecked }">
      <div>
        <div *ngIf="f.username.errors && (submitted || usernameCheck || f.username.touched)" class="invalid-feedback" [ngClass]="{ 'd-block': f.username.errors }">
          <div *ngIf="f.username.errors.required">Username is required</div>
          <div *ngIf="f.username.errors.format">Provide a valid phonenumber or username</div>
          <div *ngIf="f.username.errors.notFound">Oops... Username not found...</div>
        </div>
      </div>
      <div class="text-nowrap text-primary mt-md-1 font-weight-bolder" style="text-decoration: underline;">
        <a *ngIf="selectedRole == 'Student' && !userChecked" (click)="onForgotUsername()" href="javascript:void(0)" class="mt-10 forgot-username" [class.mobile-font]="selectedRole == 'Student'">
          Forgot Username?
        </a>
        <a *ngIf="selectedRole == 'Teacher' && !userChecked" (click)="onTeacherForgotUsername()" href="javascript:void(0)" class="mt-10 forgot-username">
          Forgot Username?
        </a>
      </div>
    </div>
  </div>

  <div class="form-group" *ngIf="userChecked">
    <label class="text-black" for="login-password">Password</label>
    <div class="input-group input-group-merge form-password-toggle">
      <input
        [type]="passwordTextType ? 'text' : 'password'" formControlName="password" autocomplete="new-password"
        class="form-control form-control-merge" placeholder="password"
        [ngClass]="{'is-invalid error': f.password.errors && (submitted || f.password.touched)}"
        aria-describedby="login-password" tabindex="2" id="login-password" />
      <div class="input-group-append">
        <span class="input-group-text cursor-pointer">
          <i class="feather font-small-4" [ngClass]="{ 'icon-eye-off': passwordTextType, 'icon-eye': !passwordTextType }" (click)="togglePasswordTextType()"></i>
        </span>
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <div>
        <div *ngIf="f.password.errors && (submitted || f.password.touched)" class="invalid-feedback" [ngClass]="{ 'd-block': f.password.errors }">
          <div *ngIf="f.password.errors.required">Password is required</div>
          <div *ngIf="f.password.errors.invalid">Oops... wrong password...try again</div>
        </div>
      </div>
      <div class="mt-md-1 text-primary font-weight-bolder" style="text-decoration: underline;">
        <a (click)="onForgotPassword()" href="javascript:void(0)">Forgot Password?</a>
      </div>
    </div>
  </div>

  <div class="form-group d-flex justify-content-between" *ngIf="userChecked">
    <div class="custom-control custom-checkbox">
      <input formControlName="rememberMe" class="custom-control-input" id="remember-me" type="checkbox" tabindex="3"/>
      <label class="custom-control-label text-black" for="remember-me">Remember Me</label>
    </div>
  </div>

  <button *ngIf="!userChecked" [disabled]="loading" class="btn btn-primary btn-block" tabindex="4" rippleEffect type="button" (click)="checkUsername()">
    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>Continue
  </button>
  <button *ngIf="userChecked" [disabled]="!userChecked || loading" class="btn btn-primary btn-block" tabindex="4" rippleEffect type="submit">
    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
    {{ selectedRole === 'Student' ? "Let's learn" : 'Continue' }}
  </button>
</form>